import React from 'react';
import { notFoundCSS } from './NotFound.css';

function NotFound(props) {
    return (
        <div css={notFoundCSS()}>
            No se ha encontrado la página solicitada
        </div>
    );
}

export {NotFound};